import {ApplicationRef, ComponentFactoryResolver, ComponentRef, Injector, Type} from '@angular/core';

export class CsAgGridJsAngularCellRenderer {
    private eGui: HTMLElement;
    private componentRef: ComponentRef<any>;

    constructor(private injector: Injector, private angularComponent: Type<any>) {
    }

    init(params: any) {
        this.createElement(params);

    }

    createElement(params: any) {
        if (!this.angularComponent) {
            this.eGui.innerText = params.value; // Fallback if no renderer is provided
            return;
        }

        const factory = this.injector.get(ComponentFactoryResolver).resolveComponentFactory(this.angularComponent);
        const appRef = this.injector.get(ApplicationRef);

        this.componentRef = factory.create(this.injector);
        this.componentRef.instance.params = params;

        appRef.attachView(this.componentRef.hostView);

        this.componentRef.changeDetectorRef.detectChanges();
        this.eGui = this.componentRef.location.nativeElement;
    }

    getGui() {
        return this.eGui;
    }

    refresh(params: any): boolean {
        if (this.componentRef && this.componentRef.instance) {
            this.componentRef.instance.params = params;
            this.componentRef.changeDetectorRef.detectChanges();
            return true;
        }
        return false;
    }

    destroy() {
        if (this.componentRef) {
            this.componentRef.destroy();
        }
    }
}
